var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddorg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_8283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.62207,
    cy: 8,
    r: 8,
    fill: "#C1C7D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28882 8H11.9555",
    stroke: "#333B4B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62207 4.66663L8.62207 11.3333",
    stroke: "#333B4B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_8283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.62207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddorg);
export default __webpack_public_path__ + "static/media/addorg.876825a11b5a1074921c0e46813adf14.svg";
export { ForwardRef as ReactComponent };